import React, { memo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import useMediaQuery from '@mui/material/useMediaQuery'
import FaqCard from 'components/FaqsPage/FaqCard'
import sx from './styles'

const FaqsVTA = ({ data = [], variant = false, showTitle = true }) => {
  const [showMore, setShowMore] = useState({})
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const toggleShowMore = (item) => {
    setShowMore({
      ...showMore,
      [item]: !showMore[item],
    })
  }

  return (
    <Container sx={sx.faqsContainer}>
      {
        showTitle && (
          <Box
            sx={sx.showTitle}
          >
            <Typography variant="h3">
              <FormattedMessage id="SYC_FAQS_TITLE" />
            </Typography>
          </Box>
        )
      }

      {data.map((category, i) => (
        <Box
          key={`category-id-${i}`}
          sx={sx.faqCategory}
          component="section"
          item
          container
        >
          <Grid
            container
            spacing={isMobile ? 4 : 2}
          >
            {category?.questions
              ?.filter((_, index) => (showMore[i] ? true : index < (variant ? 0 : 4)))
              ?.map((item) => (
                <Grid
                  key={item.question}
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FaqCard
                    item={item}
                    variantComponentFaqTitle="h3"
                    formattedMessageEnabled
                  />
                </Grid>
              ))}

          </Grid>
          <Box sx={sx.showMore}>
            <Typography
              id="show-more-show-less"
              variant="link-text"
              sx={sx.showMoreLink}
              onClick={() => toggleShowMore(i)}
            >
              <FormattedMessage id={!showMore[i] ? 'SEE_ALL' : 'SEE_LESS'} />
            </Typography>
            {!showMore[i] ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </Box>
        </Box>
      ))}
    </Container>
  )
}

export default memo(FaqsVTA)
